export const SET_GA_LIST_INFO_VIEW = "SET_GA_LIST_INFO_VIEW"

export const setGAInfoViewList = (payload) => async (dispatch) => {
    // console.log(payload, 'meter list')
    dispatch({
        type: SET_GA_LIST_INFO_VIEW,
        payload

    })
}